import { render, staticRenderFns } from "./BrandTutorialVideoPopup.vue?vue&type=template&id=53c8eaaf&scoped=true&"
import script from "./BrandTutorialVideoPopup.vue?vue&type=script&lang=js&"
export * from "./BrandTutorialVideoPopup.vue?vue&type=script&lang=js&"
import style0 from "./BrandTutorialVideoPopup.vue?vue&type=style&index=0&id=53c8eaaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c8eaaf",
  null
  
)

export default component.exports